import { BankAccountContainer } from 'features/BankAccount/BankAccountContainer'
import { TBusinessAccountDetails } from 'features/MyCommunity/BankingSetupCommunity/types'

export const HSDetailsBankAccountsContainer = ({
  businessAccountDetails,
  getBusinessAccountDetails
}: {
  businessAccountDetails?: TBusinessAccountDetails
  getBusinessAccountDetails: () => void
}) => {
  if (!businessAccountDetails) return null

  return (
    <BankAccountContainer
      businessDetails={businessAccountDetails}
      getBusinessDetails={getBusinessAccountDetails}
    />
  )
}
